export const HOME = '/'
export const DOCS = '/docs'